import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { MycurrencyFrPipe } from './mycurrencyFr.pipe';
@Directive({
  selector: '[appMycurrencyFr]'
})
export class MycurrencyDirectiveFr implements OnInit {
  private el: any;
  maxLength: number;
  constructor(
    private elementRef: ElementRef,
    private formatcurrencypipe: MycurrencyFrPipe
  ) {
    this.el = this.elementRef.nativeElement;
    this.maxLength = this.el.maxLength;
  }
  ngOnInit() {
    if (!this.el.value) {
      this.el.value = ""
    }
    else {
      this.el.value = this.formatcurrencypipe.transform(this.el.value, 0, this.maxLength);

    }
  }
  @HostListener("focus", ["$event.target.value", "$event"])
  onFocus(value, event) {
    if (event.which == 9) {
      return false;
    }
    this.el.value = value.replace(/\s/g, '');
    this.el.select();

  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    let arrVal = value;
    if (arrVal.trim().indexOf(' ') > -1) {
      let commaArr = arrVal.split(" ")
      this.el.value = this.formatcurrencypipe.transform(commaArr.join(''), 0, this.maxLength);
      return;

    } else {
      this.el.value = this.formatcurrencypipe.transform(arrVal, 0, this.maxLength);
    }
  }
  @HostListener('keydown', ['$event', "$event.target.value"]) onKeyDown(event, value) {
    let e = <KeyboardEvent>event;
    if (e.key == ".") {
      e.preventDefault();
      return;
    }
    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();

    }

    this.el.value = value.trim(); // opossite of transform
  }

}